var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',{attrs:{"value":_vm.id,"items":_vm.items,"label":"Realm","item-value":"id","item-text":_vm.name,"multiple":_vm.multiple,"prepend-icon":_vm.icon,"outlined":_vm.outlined,"dense":_vm.dense,"clearable":_vm.clearable},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }